export const notesFrequency = [
  {text:'First',value:'First',key:'First'},
  {text:'Second',value:'Second',key:'Second'},
  {text:'Split',value:'Split',key:'Split'}
]